"use strict"

module agi.expressions.card {
    export class Config {
        public static SCALE_FACTOR:number = 1;
        public static X_OFFSET:number = 0;
        public static Y_OFFSET:number = 0;
        public static IS_SQUARE:boolean = true;
        public static IS_PORTRAIT:boolean = false;
        public static IS_DESKTOP_VIEW = false;
        public static SHOW_MENU = false;
        public static BASE_WIDTH = 550;
        public static BASE_HEIGHT = 550;
        public static SQUARE_SIZE = 550;
        public static DESKTOP_CANVAS_WIDTH = 800;
        public static DESKTOP_FRAME_WIDTH = 960;
        public static DESKTOP_FRAME_HEIGHT = 800;
        public static ASSET_PATH = "";
        public static DEFAULT_PERS = {};
    }
}
